// extracted by mini-css-extract-plugin
export default {"cls1":"r3Xc05MH8RPwLoH6K5Zu","cls2":"mdKhuSPNhiloI3MGBXU_ r3Xc05MH8RPwLoH6K5Zu","isTabletDown":"nmOBaz0M_NIZvNbahuds"};